import scroller from './v1Scroller';

export default function v1Features() {
  const features = () => {
    const selectbox = document.getElementById('v1-recommendationSelectbox__toggle');

    // Features用のselectboxが無い場合は処理しない
    if (!selectbox || !selectbox.classList.contains('-features')) return;

    const selectContent = document.getElementById('v1-recommendationSelectbox__content');
    const featuresList = document.getElementById('v1-recommendationItinerariesList');
    const noResult = document.getElementById('v1-selectBox__result');

    /**
     * リストまでスムーススクロールする
     */
    const listScroll = () => {
      scroller.toElement(selectbox);
    };

    /**
     * リストにフォーカスする
     */
    const listFocus = () => {
      featuresList.setAttribute('tabindex', 0);
      featuresList.focus();
      featuresList.removeAttribute('tabindex');
    };

    /**
     * eventに連動してselectboxを閉じる
     * @param {String} event
     */
    const closeSelectbox = event => {
      const isEscape = event.key === 'Escape' || event.code === 'Escape' || event.key === 'Esc';
      const button = selectContent.querySelectorAll('button');
      const buttonId = document.getElementById(event.target.id);
      const index = [].slice.call(button).indexOf(buttonId);
      const isLast = button.length - 1 === index;

      // escapeキーが最後の要素のときはselectboxを閉じてリストへフォーカスを移動させる
      if (isEscape || isLast) {
        selectbox.click();
        featuresList.focus();
      }
      // escapeキーを押したときはselectboxを閉じる
      if (isEscape) {
        selectbox.focus();
      }
    };

    /**
     * selectboxのラベルを引数の値に書き換える
     * @param {String} label ラベルの値
     */
    const changeSelectText = label => {
      const selectTitle = selectbox.querySelector('.v1-recommendationSelectbox__text');
      selectTitle.innerText = label;
    };

    /**
     * エリア名で特集リストのアイテムを絞り込む
     * @param {String} erea 絞り込みのエリア名
     */
    const filterArea = area => {
      const item = featuresList.querySelectorAll('.v1-features__listItem');
      const node = Array.prototype.slice.call(item, 0);
      const count = node.filter(areaItem => areaItem.classList.contains(area));

      // 絞り込み結果が0の場合は、結果無しテキストを表示する
      if (area !== 'all' && count.length === 0) {
        noResult.classList.add('-show');
      } else {
        noResult.classList.remove('-show');
      }

      // 特集の表示/非表示を切り替える
      node.forEach(element => {
        const listItem = element;

        // classが一致するかどうかで表示を切り替え
        if (listItem.classList.contains(area)) {
          listItem.style = 'display: block';
        } else if (area === 'all') {
          listItem.style = 'display: block';
        } else {
          listItem.style = 'display: none';
        }
      });

      // リストまでスクロール
      listScroll();
      // リストへフォーカス
      listFocus();
    };

    /**
     * selectboxのラベルをクリックで、エリア選択ボタンの表示/非表示を切り替える
     */
    const toggleSelectbox = () => {
      selectbox.addEventListener('click', () => {
        // エリア選択ボタンの表示切替 aria-expanded
        selectContent.classList.toggle('-open');
        if (selectContent.getAttribute('aria-hidden') === 'true') {
          selectContent.removeAttribute('aria-hidden');
        } else {
          selectContent.setAttribute('aria-hidden', 'true');
        }

        const expand = selectbox.getAttribute('aria-expanded');

        // ラベルの状態切替 aria-expanded
        if (expand === 'false') {
          selectbox.setAttribute('aria-expanded', 'true');
          selectbox.setAttribute('aria-pressed', 'true');
        } else {
          selectbox.setAttribute('aria-expanded', 'false');
          selectbox.setAttribute('aria-pressed', 'false');
        }

        // 展開時はエリア選択ボタンにフォーカス
        if (expand === 'false') {
          const firstChild = selectContent.querySelector('button');

          setTimeout(() => {
            firstChild.focus();
          }, 100);
        }
      });
    };

    /**
     * selectboxのエリア選択ボタンをクリックで、ラベルの文言を切り替え後、リストを絞り込む
     */
    const selectArea = () => {
      const selectButton = selectContent.querySelectorAll('.v1-recommendationSelectbox__button');
      const node = Array.prototype.slice.call(selectButton, 0);
      node.forEach(element => {
        element.addEventListener('click', () => {
          const buttonLabel = element.innerText;
          const buttonKey = element.getAttribute('id');

          // selectboxのラベルをボタンの文言と同じテキストに切り替える
          changeSelectText(buttonLabel);
          // ボタンを閉じる
          selectbox.click();
          // 一旦、ボタンのスタイルの選択状態を解除する
          node.forEach(button => {
            button.removeAttribute('aria-selected');
            button.removeAttribute('aria-checked');
          });
          // 選択したボタンのみスタイルを選択状態にする
          element.setAttribute('aria-selected', 'true');
          element.setAttribute('aria-checked', 'true');

          // 特集リストの絞り込み
          filterArea(buttonKey);
        });

        // escapeキー操作の場合、selectboxを閉じる
        element.addEventListener('keydown', event => {
          closeSelectbox(event);
        });
      });
    };

    toggleSelectbox();
    selectArea();
  };

  features();
}
